import {useSongDetailsRouterParams} from "./useSongDetailsRouterParams";
import {useAppSelector} from "../../../../../redux/hooks";
import {
  getMySongsPageSongSelectedSongDetailsFirstLessonId
} from "../../../modules/my-songs-page-store/mySongsPage.selectors";


export interface ISongDetailsDisplaySelectedLessonLogic {
  songId: number;
  lessonId?: number;
  firstLessonId?: number;
}

export const useSongDetailsDisplaySelectedLesson = (): ISongDetailsDisplaySelectedLessonLogic => {
  const {songId, lessonId} = useSongDetailsRouterParams();
  const firstLessonId = useAppSelector(getMySongsPageSongSelectedSongDetailsFirstLessonId);

  return {
    songId,
    lessonId,
    firstLessonId,
  };
};
